<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<h2 class="fmtitle">Dedication</h2>
<p class="noindent">To the memory of the twenty-one men of the 1st Suffolk who died on active service during the Malayan Emergency. This work is dedicated in proud and affectionate remembrance of them:</p>
<p class="noindentqt">22221729 Sgt. J.A. Ashdown</p>
<p class="noindentq">5837855   Sgt. D. Westin</p>
<p class="noindentq">22305572 Cpl. S. Bailey</p>
<p class="noindentq">5883960   Cpl. H. Holland</p>
<p class="noindentq">21059924 L/Cpl. F.T.C. Mallows</p>
<p class="noindentq">14459864 L/Cpl. H.R. Simmonds</p>
<p class="noindentq">5775902   L/Cpl. S.E. Thompsett</p>
<p class="noindentq">22614578 Pte. B.V. Ansell</p>
<p class="noindentq">22259033 Pte. J.D. Edwards</p>
<p class="noindentq">22322782 Pte. L.G. Killick</p>
<p class="noindentq">22602535 Pte. B. Larman</p>
<p class="noindentq">22329839 Pte. F.L. Lewis</p>
<p class="noindentq">21041416 Pte. R.A. Mills</p>
<p class="noindentq">22403901 Pte. R. Moore</p>
<p class="noindentq">22078754 Pte. D. Nobbs</p>
<p class="noindentq">14217245 Pte. L.R. Payne</p>
<p class="noindentq">5774520   Pte. W.G. Pearce</p>
<p class="noindentq">22350436 Pte. E.A. Riches</p>
<p class="noindentq">5837859   Bdm. M.S. Swann</p>
<p class="noindentq">22444978 Pte. H. Walker</p>
<p class="noindentq">22395548 Pte. D. Wilson</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?de0c4772